import { ITripErrors } from './trip-schema.interface';

export interface ITripInformationSchema {
    tripCode: string;
    start: string;
    realKm: string;
    vehicle?: string;
    vehicleName?: string;
    vehicleId?: string;
    driver?: string;
    driverId?: string;
    carrier?: string;
    carrierId?: string;
    accounts?: string[];
    semitrailersLicensePlates?: string[];
    errors?: ITripErrors[];
}
